export default {
    'confirmed': 'Confirmed',
    'cancelled': 'Cancelled',
    'settled': 'Rozliczona',
    'finished': 'Finished',
    'rejected': 'Rejected',
    'waiting_for_business_approval': 'Waiting for partner approval'
}